/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import TableHeader from "../../Components/Common/TableHeader";
import Loader from "../../Components/Common/Loader";
import TransactionsTable from "../Common/Transactions/TransactionsTable";
import Pagination from "../Common/Pagination";
import TransactionsSearchForm from "../Common/Transactions/TransactionsSearchForm";
import ajaxBank from "../../util/remote/ajaxBank";

function CallTransactions() {

  const [callTransactions, setCallTransactions] = useState(false);
  const [callSearchTerm, setCallSearchTerm] = useState("");
  const [callStartDate, setCallStartDate] = useState("");
  const [callEndDate, setCallEndDate] = useState("");
  const [callPage,setCallPage] = useState(1)
  const [callMeta,setCallMeta] = useState([])
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const getCallTransactions = async (currentPage) => {
      setLoading(true);
      const server_response = await ajaxBank.fetchCallTransactions(currentPage);
      setLoading(false);
      if (server_response.status === "OK") {
        setCallMeta(server_response.details.meta.totalPages);
        setCallTransactions(server_response.details.list || []);
      } else {
        setCallTransactions([]);
      }
  };

  const searchCallTransactions = async (e) => {
      if (e) {
          e.preventDefault();
      }
      setLoading2(true);
      const server_response = await ajaxBank.searchCallTransactions(callSearchTerm, callStartDate, callEndDate, callPage);
      setLoading2(false);
      if (server_response.status === "OK") {
        setCallMeta(server_response.details.meta.totalPages);
        setCallTransactions(server_response.details.list || []);
      } else {
        setCallTransactions([]);
      }
    
    };
  const setCall = (e) => {
    e.preventDefault();
    setCallSearchTerm("");
    setCallStartDate("");
    setCallEndDate("");
    setCallPage(1);
    getCallTransactions(1);
  
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= callMeta) {
      setCallPage(newPage);
    }
  };

  const headers = [
    { label: "Transaction Date", key: "created_at" },
    { label: "User Details", key: "user" },
    { label: "Amount", key: "cash_out" }

  ];

  useEffect(() => {
    if (callSearchTerm || callStartDate || callEndDate) {
      searchCallTransactions();
    } else {
      getCallTransactions(callPage);
    }
  }, [callPage]);

  return (
      <>
      <div class="heading-layout1 mg-b-5">
        <TableHeader subtitle="List of all the call transactions made sorted by the most recent"/>

        
      </div>

      <TransactionsSearchForm searchTerm={callSearchTerm} setSearchTerm={setCallSearchTerm} startDate={callStartDate}
         setStartDate={setCallStartDate} endDate={callEndDate} setEndDate={setCallEndDate} searchTransactions={searchCallTransactions}
         setTransactions={setCall} setPage={setCallPage} searchTermPlaceholder="Enter first or last name of user..."/>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
        {loading || loading2 ? (
          <Loader />
        ) : (
          <TransactionsTable headers={headers} data={callTransactions} isPMTransaction={true}/>
        )}
      </div>
      <Pagination currentPage={callPage} totalPages={callMeta} onPageChange={handlePagination}/>
    </>
     
  
  );
}

export default CallTransactions;
